import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, catchError, throwError } from "rxjs";
import { EmailRegistroDTO } from 'src/app/dto/EmailRegistroDTO';
import { UsuarioRegistroDTO } from 'src/app/dto/UsuarioRegistroDTO';
import { CONSTANTES } from '../../shared/constanst/url-scrolls-header';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {

  params: any = {
    responseType: 'text'
  };

  constructor(private http: HttpClient) { }

  registrarUsuario(request: UsuarioRegistroDTO): Observable<any> {

    return this.http.post
    (
      `${CONSTANTES.URL_PRODUCCION}/registro`, 
      request, 
      this.params
    ).pipe(
      tap(response => {
        // Almacena la respuesta para usarla luego en el guard o en otros componentes
        console.log(response);
      })
    );
  }


  // enviarEmailConfirmacion(request: EmailRegistroDTO): Observable<any> {

  //   return this.http.post
  //   (
  //     `${CONSTANTES.URL_PRODUCCION}/enviar-formulario`, 
  //     request, 
  //     this.params
  //   ).pipe(
  //     tap(response => {
  //       // Almacena la respuesta para usarla luego en el guard o en otros componentes
  //       console.log(response);
  //     })
  //   );
  // }

  enviarEmailConfirmacion(request: EmailRegistroDTO): Observable<any> {
    return this.http.post(`${CONSTANTES.URL_PRODUCCION}/enviar-formulario`, request, this.params)
      .pipe(
        tap(response => {
          console.log('Respuesta del servidor:', response);
        }),
        catchError(error => {
          console.error('Error al enviar email de confirmación:', error);
  
          let errorMsg = 'Ocurrió un error inesperado';
  
          if (error.error instanceof ErrorEvent) {
            // Error del lado del cliente
            errorMsg = `Error del cliente: ${error.error.message}`;
          } else {
            // Error del lado del servidor
            switch (error.status) {
              case 400:
                errorMsg = 'Solicitud incorrecta. Verifica los datos enviados.';
                break;
              case 401:
                errorMsg = 'No autorizado. Verifica tus credenciales.';
                break;
              case 403:
                errorMsg = 'Acceso prohibido.';
                break;
              case 404:
                errorMsg = 'No se encontró el recurso solicitado.';
                break;
              case 500:
                errorMsg = 'Error interno del servidor. Inténtalo más tarde.';
                break;
              default:
                errorMsg = `Error desconocido: ${error.message}`;
            }
          }
  
          return throwError(() => new Error(errorMsg));
        })
      );
  }
  
}
